<section class="question watermarked" *ngIf="question">
  <header class="question__header has-person-id">
    <h1 class="question__number">Question {{question.sequence}} of {{totalQuestions}}
      :
      <span *ngIf="question.isCorrect === true" class="question__result question__result--correct">Correct</span>
      <span *ngIf="question.isCorrect === false" class="question__result question__result--incorrect">Incorrect</span>
      <span *ngIf="question.isCorrect === null" class="question__result question__result--incorrect">No Answer Selected</span>
    </h1>
    <div *ngIf="!showMessage" class="question__peer-comparison">{{getPercentage()}}% of your peers
      got this
      correct</div>
    <div *ngIf="showMessage" class="question__peer-comparison">{{message}}</div>
    <div class="person-id">{{personId}}</div>
  </header>
  <div class="question__description rte-content" [innerHTML]="question.stem | safeHtml">
  </div>
  <div class="question-choices">
    <div [ngClass]="option.isSelectedOption?'question-choice question-choice-result question-choice-result--selected':'question-choice question-choice-result'"
      *ngFor="let option of question.options">
      <div class="question-choice-result__text-wrap">
        <span [ngClass]="option.isAnswer ? 'question-choice-result__icon icon icon--check question-choice-result__icon--correct':'question-choice-result__icon icon icon--close question-choice-result__icon--incorrect'"></span>
        <div class="question-choice__text" [innerHTML]="option.text | safeHtml"></div>
      </div>
      <p class="question-choice-result__explanation" [innerHTML]="option.explanation | safeHtml"></p>
    </div>
  </div>
  <div *ngIf="question.reference && question.reference !== ''">
    <h2>References</h2>
    <p [innerHTML]="question.reference | safeHtml"></p>
    <div class="cart__actions">
      <button class="button button--tertiary " (click)="emailReferences()">
          <i class="button__icon icon icon--print"></i>
          <span class="button__text">Email Reference</span>
      </button>    
      <button class="button button--tertiary " (click)="printReferences()">
        <i class="button__icon icon icon--print"></i>
        <span class="button__text">Copy Reference</span>
      </button>
    </div>
  </div>
</section>